export default "__VITE_ASSET__d5b26561__"